import * as yup from 'yup';

/**
 * '' is "not entered" for an optional numeric field; without this, yup.number() casts '' to NaN.
 * These fields' own input mask also accepts a comma as a decimal separator, which yup's built-in
 * Number() cast does not understand (it casts "250,50" to NaN, failing validation before this
 * transform even runs) -- re-parsed from the original string here rather than trusting that cast.
 */
const blankToNull = (value, originalValue) => {
  if (String(originalValue).trim() === '') return null;
  return typeof originalValue === 'string' ? parseFloat(originalValue.replace(',', '.')) : value;
};
export const billSchema = yup.object({
  amount: yup.number().positive().nullable(false).required(),
  attachFile: yup.string().notRequired(),
  // LB-5835: submeter-only, optional. Dollars, zero or more.
  baseChargeAmount: yup.number().min(0, 'Base charge cannot be negative.').nullable().transform(blankToNull).notRequired(),
  commonAreaDeduction: yup.number(),
  // LB-5835: submeter-only, optional. Dollars, zero or more.
  consumptionCharges: yup.number().min(0, 'Consumption charges cannot be negative.').nullable().transform(blankToNull).notRequired(),
  date: yup.object().shape({
    startDate: yup.string().required(),
    endDate: yup.string().required()
  }),
  goodWillDeduction: yup.number().test({
    name: 'max',
    test: function () {
      let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return value + this.parent.commonAreaDeduction <= 100;
    }
  }).required(),
  // LB-5835: submeter-only, optional, greater than zero only when consumptionCharges is also
  // greater than zero.
  totalUsage: yup.number().nullable().transform(blankToNull).notRequired().test({
    name: 'totalUsage-required-if-consumptionCharges',
    message: 'Bill usage must be greater than zero when consumption charges is greater than zero.',
    test(value) {
      const consumptionCharges = this.parent.consumptionCharges;
      if (!(consumptionCharges > 0)) return true;
      return typeof value === 'number' && value > 0;
    }
  })
});

// billSchema minus the submeter-only rules, for use when the submeter-billing flag is off.
export const baseBillSchema = billSchema.omit(['baseChargeAmount', 'consumptionCharges', 'totalUsage']);